import Api from '@/models/Api'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'
import moment from 'moment'

export default class SoldOfForecastWidget extends SystemDashboardWidget {
  public title: string = 'Sold of Forecast'

  public key: string = 'sold_of_forecast'

  public view: string = 'card'

  public query: string[] = []

  // API Filters
  public filters: any = {
    region: 'all',
    product: 'all',
  }

  public internalFilters: any = {
    start: moment().startOf('year').format('YYYY-MM-DD'),
    end: moment().endOf('year').format('YYYY-MM-DD'),
  }

  public flattenPayload: boolean = true

  public size: any = {
    sm: 12,
    md: 6,
    lg: 3,
  }

  public dataSource() {
    let api = new Api()

    return api
      .get('leadership-dashboard/overview', this.payload)
      .then((response: any) => response.data.result)
      .catch((err: any) => ({ data: [] }))
  }

  protected dataMapper(data: any): Promise<any> {
    this.title = `Sold of ${data.reforecast_name}`
    return Promise.resolve(` <div class="text-center p-4">
        <div class="d-flex justify-content-center">
         <h4>${data['sold_of_%%reforecast_name%%']}</h4>
          </div>
        </div>`)
  }
}
